// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3cIFv","label":"LabeledBox_label__5ICbP"};